module.exports = __webpack_public_path__ + "client side elderly.svg?7ba14f993fd8182372011a2fa97d1f9b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/client side elderly.svg
// module id = 63
// module chunks = 0